import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCustomerDiscountModel } from "../customerDiscountModel";
import { ICustomerDiscountDetail } from "../customerDiscountService";
import useGlobalModel from "@/model/globalModel";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useCustomerDiscountModel();
    const { getDictNodeName } = useGlobalModel(() => []);
    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ICustomerDiscountDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '客户优惠单号',
            width: 180,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
            fixed: "left",
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '销售单位',
            width: 160,
            dataIndex: 'bentityName',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            render: text => getDictNodeName(text ?? "")
        }, {
            title: '优惠账户编码',
            width: 140,
            dataIndex: 'accountCode',
        }, {
            title: '优惠账户名称',
            width: 160,
            dataIndex: 'accountName',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '优惠金额',
            width: 100,
            dataIndex: 'discountAmount',
        }, {
            title: '申请人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '申请日期',
            width: 180,
            dataIndex: 'createTime',
        }, {
            title: '机构审核人',
            width: 160,
            dataIndex: "audit"
        }, {
            title: '机构审核日期',
            width: 180,
            dataIndex: "auditTime"
        }, {
            title: '财务',
            width: 100,
            dataIndex: 'casher',
        }, {
            title: '财务审核日期',
            width: 180,
            dataIndex: "casherTime"
        }, {
            title: '客户编码',
            width: 160,
            dataIndex: "customerCode"
        }, {
            title: '联系人',
            width: 100,
            dataIndex: "contact"
        }, {
            title: '电话',
            width: 100,
            dataIndex: "phone"
        }, {
            title: '申请说明',
            width: 180,
            dataIndex: "applyExplain"
        },
    ];


    //点击行选高亮
    const onRow = (record: ICustomerDiscountDetail) => {
        let findObj = selectedRowKeys.find(item => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.id !== record.id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.id);
                            return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.id)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}
